import styled from "styled-components";
import NavBack from "../../assets/icon/lnb_next_arrow.png";

export const Page = styled.div`
  min-height: calc(100vh - 68px);
  padding-top: 68px;
  width: 100vw;
  background-color: var(--semi-brown);
  margin-bottom: 60px;
  .section {
    box-shadow: 5px 5px 5px rgba(54, 28, 11, 0.1);
    background-color: var(--white);
    min-height: 800px;
    width: 1280px;
    margin: auto;
    border: 1px solid #d9d1ca;
    @media (max-width: 1280px) {
      width: 90vw;
    }
  }

  .inner {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 50px 60px 50px;
    @media (max-width: 1024px) {
      padding: 0px 12px 24px 12px;
    }
  }

  .page-text {
    padding: 0 30px 0px 30px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    line-height: 1.9;
    font-size: 18px;
    margin-top: 24px;

    .page-text-flex {
      display: flex;
      gap: 60px;
      margin-bottom: 24px;
    }

    .page-text-title {
      font-weight: bold;
      font-size: 24px;
    }

        @media (max-width: 768px) {
      font-size: 14px;
      padding: 0 12px 0px 12px;
      word-break: keep-all;
      margin-top: 12px;

      .hat-img {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        height: auto !important;
        width: 100% !important;
      }
    }
    .page-text-flex {
      display: block;
      > div {
        width: 100%;
        margin-bottom: 12px;
      }
    }
    .page-text-title {
      font-size: 16px;
    }
  }
  }

  .hat-img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    height: 300px;
  }

  .fullsize-map {
    width: 100%;
    margin-top: 60px;

     @media (max-width: 768px) {
    margin-top : 24px;
  }
  }

   &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }
  }


  .business-map {
    position: relative;
    width: 100%;
    margin-top: 32px;

    .fullsize-map {
      display: block;
      width: 100%;
      height: auto;
      margin-top: 0;
    }

    .cypress-link {
      position: absolute;
      display: block;
      z-index: 10;
      cursor: pointer;
    }
  }

  /* 한글 이미지 */
  .business-map-kor {
    .cypress-link {
      left: 33.2%;
      top: 25.7%;
      width: 19%;
      height: 2.4%;
    }
  }

  /* 영문 이미지 */
  .business-map-eng {
    .cypress-link {
      left: 63%;
      top: 25.5%;
      width: 19%;
      height: 2.8%;
    }
  }
`;

export const PageTopLine = styled.div`
  width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 40px;

  .page-top-line-title {
    font-size: 40px;
    color: var(--dark);
    font-weight: bold;
  }
  .page-top-line-left {
    img {
      width: 140px;
    }
  }
  .page-top-line-right {
    width: 140px;
  }
  @media (max-width: 1280px) {
    width: 90vw !important;
    margin: auto;
    display: block;
    text-align: center;
  }
`;
export const PageNavidation = styled.div`
  background-color: #faf8f6;
  box-shadow:0 2px 2px rgba(54,28,11,.05);
  border-bottom : 1px solid #ccc;
  height : 52px;
  display : flex;
  align-items : center;
 
  .logo{
    width : 80px;
    height : 100%;
    display : flex;
    align-items : center;
    justify-content : center;
    background-image: url(${NavBack}) ;
    background-repeat: no-repeat;
    background-position : right;
    svg{
      width : 13px;
      height : 11px;
    }
}

@media (max-width: 768px){

  &>div:nth-child(-n+2) {
    display : none !important;
  }

  &>a{
    display : none !important;
  }
    &>div{
      width : auto !important;
      padding-right : 60px;
      a{
      font-size : 14px;
      }
    }

  .open-list{
    left : 0px !important;
  font-size : 14px;
    }
}
.`;

export const Nav = styled.div`
  background-image: url(${NavBack});
  background-repeat: no-repeat;
  background-position: right;
  width: 24%;
  height: 52px;
  position: relative;
  .down-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
  }

  cursor: pointer;
  &:hover .open-list,
  .open-list:hover {
    height: ${(props) => props.height};
    border: 1px solid #ccc;
    background-color: var(--white);
  }

  .open-list {
    position: absolute;
    top: 52px;
    left: -24px;
    box-sizing: border-box;
    z-index: 50;
    height: 0px;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    width: 100%;
    border: none;
  }
`;
export const NavItem = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 18px;
  width: 100%;
  padding-left: 23px;
  color: var(--purple);

  &.list-inner-item {
    &:hover {
      background-color: var(--semi-brown);
      text-decoration: underline;
    }
  }
`;

export const PageTitle = styled.div`
  display: flex;
  align-items: center;
  padding-top: 45px;
  span {
    width: 10px;
    background-color: var(--purple);
    height: 52px;
  }

  .title {
    margin-left: 20px;
    font-size: 36px;
    font-weight: bold;
    color: var(--dark);
  }

  a {
    display: block;
    margin-left: 24px;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--purple);
    color: var(--white);
    margin-top: 4px;
    padding: 8px 20px;
  }

  @media (max-width: 768px) {
    padding-top: 24px;
    span {
      width: 5px;
      height: 32px;
    }
    .title {
      margin-left: 12px;
      font-size: 24px;
    }
  }
`;

export const ImgHolderFullsize = styled.div`
  // background-color: var(--purple);
  width: 100%;
  padding-top: 16px;
  border-radius: 28px;
  margin-top: 16px;
  .holder-img {
    width: calc(100% - 32px);
    border-radius: 20px;
    margin: auto;
    display: block;
    height: 400px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 20px;
    text-align: center;
    color: var(--white);
  }

  .plus {
    object-fit: cover;
  }

  @media (max-width: 768px) {
    margin-top: 12px;
    border-radius: 15px;
    padding-top: 12px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 24px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
`;
export const ImgHolderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;

  &.center {
    justify-content: center;
    gap: 24px;
    img {
      width: 40%;
    }
  }
  .fullsizeItem {
    width: 50% !important;
  }
  @media (max-width: 768px) {
    margin-top: 12px;
    &.center {
      justify-content: center;
      gap: 12px;

      & > img {
        height: 120px;
      }
    }
  }
`;
export const ImgHolderHarf = styled.div`
  background-color: var(--purple);
  width: calc(50% - 8px);
  padding-top: 16px;
  border-radius: 28px;
  .holder-img {
    width: calc(100% - 32px);
    border-radius: 20px;
    margin: auto;
    display: block;
    height: 300px;
    object-fit: cover;
  }

  .holder-name {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 20px;
    text-align: center;
    color: var(--white);
  }

  @media (max-width: 768px) {
    border-radius: 15px;
    width: calc(50% - 8px);

    padding-top: 12px;
    .holder-img {
      border-radius: 10px;
      height: 120px;
      width: calc(100% - 24px);
    }
    .holder-name {
      font-size: 14px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
`;

export const HistoryTable = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--purple);
  margin-top: 24px;
  overflow: hidden;

  .history-table-head {
    border-bottom: 1px solid var(--purple);
    display: flex;
    align-items: center;
    background-color: var(--purple);
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    .history-table-ceil-big {
      padding-left: 20px;
    }
  }

  .history-table-line {
    border-bottom: 1px solid var(--purple);
    display: flex;

    font-size: 14px;
    font-weight: bold;
  }

  .history-table-ceil-small {
    width: 150px;
    border-right: 1px solid var(--purple);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 16px;
    padding-top: 16px;
  }
  .history-table-ceil-big {
    width: calc(100% - 150px);
    text-align: left;
    padding-bottom: 16px;
    padding-top: 16px;
  }

  .history-table-ceil-big > div {
    padding-left: 16px;
    padding-right: 16px;
  }
  .last-line {
    border-bottom: 0px !important;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: var(--purple);
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .ceil-kor {
    font-weight: bold;
    @media (max-width: 768px) {
      word-break: keep-all;
    }
  }
  .ceil-end {
    font-weight: lighter;
  }
`;

export const SaleItemList = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 24px;
`;
export const SaleItem = styled.div`
  width: calc((100% - 48px) / 3);
  background-color: var(--purple);
  border-radius: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  > img {
    width: calc(100% - 56px);
    padding: 16px;
    display: block;
    margin: auto;
    border-radius: 15px;
    height: 123px;
    background-color: var(--white);
  }
`;
